module.exports = __webpack_public_path__ + "a39dd7650d6454698a98ddc765c3af45.png";